import type { SellerApplicationRejectionKind } from './api/seller-applications-moderation.api';

/** Синхронно с Prisma enum и подписями на бэкенде. */
export const SELLER_APPLICATION_REJECTION_LABELS: Record<
  SellerApplicationRejectionKind,
  string
> = {
  POOR_DOCUMENT_PHOTOS: 'Некачественные фото документов',
  DATA_MISMATCH: 'Несоответствие данных документов сведениям в анкете',
  INCOMPLETE_DOCUMENTS: 'Неполный комплект документов',
  REQUIRES_REVISION: 'Требуется доработка заявки',
};

export const SELLER_APPLICATION_REJECTION_OPTIONS: {
  value: SellerApplicationRejectionKind;
  label: string;
}[] = (
  Object.entries(SELLER_APPLICATION_REJECTION_LABELS) as [
    SellerApplicationRejectionKind,
    string,
  ][]
).map(([value, label]) => ({ value, label }));
